<style lang="scss" scoped="">

  .order-list-item {
    cursor: pointer;
  }

  .header-list {
    overflow: hidden;
  }

  .opera-btn-group {
    margin-left: 0;
    margin-right: 0;
  }
</style>
<template>
  <div>
    <el-table v-loading="loadingData" :data="list" class="header-list border-black"
              :header-row-class-name="'headerClass'" style="width: 100%">
      <el-table-column prop="orderNo" label="订单编号"></el-table-column>
      <el-table-column prop="availableCount" label="合格业务库存" width="70"></el-table-column>
      <el-table-column prop="unqualifiedBizCount" label="不合格业务库存" width="70"></el-table-column>
      <el-table-column prop="undeterminedCount" label="业务停销"></el-table-column>
      <el-table-column prop="qualifiedActualCount" label="合格实物库存" width="70"></el-table-column>
      <el-table-column prop="unqualifiedActualCount" label="不合格实物库存" width="70"></el-table-column>
      <el-table-column prop="transitCount" label="在途库存"></el-table-column>
      <el-table-column prop="actionTitle" label="操作类型"></el-table-column>
      <el-table-column prop="createTime" label="操作时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | time}}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="text-center" v-show="list.length && !loadingData">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :total="pager.count" :pageSize="pager.pageSize" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :page-sizes="[10,20,50,100]" :current-page="pager.currentPage">
      </el-pagination>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      id: String
    },
    data() {
      return {
        list: [],
        loadingData: false,
        pager: {
          currentPage: 1,
          count: 0,
          pageSize: 20
        }
      };
    },
    watch: {
      id: {
        handler() {
          this.queryList();
        },
        immediate: true
      }
    },
    methods: {
      handleSizeChange(val) {
        this.pager.pageSize = val;
        this.queryList(1);
      },
      handleCurrentChange(val) {
        this.queryList(val);
      },
      queryList(pageNo) {
        this.list = [];
        if (!this.id) return;
        this.pager.currentPage = pageNo;
        let params = Object.assign({}, {
          pageNo: pageNo,
          pageSize: this.pager.pageSize,
        });
        this.loadingData = true;
        let nowTime = new Date();
        this.nowTime = nowTime;
        let url = this.$route.meta.type === 'flow' ? `bsp-stock/${this.id}/log/group` : `bsp-stock/${this.id}/log`;
        this.$http.get(url, {params}).then(res => {
          if (this.nowTime > nowTime) return;
          this.list = res.data.list || [];
          this.pager.count = res.data.count;
          this.loadingData = false;
        }).catch(() => {
          this.loadingData = false;
        });
      }
    }
  };
</script>
